<template>
  <a-modal
    title="问诊详情"
    :width="900"
    :visible="visible"
    okText=''
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    v-if="hackReset"
  >
  <template #footer>
    <a-button key="back" @click="handleCancel">取消</a-button>
  </template>
    <div>
      <div class="viewDetial-title">患者信息</div>
      <div>
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="12" :sm="24" style="padding-left:40px">
              <a-form-item label="姓名："> {{ this.userDate.patientName }}   {{ this.userDate.patientSex == '1' ? '/男' : '/女' + '/' + this.userDate.patientAge }} </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="问诊时间："> {{this.userDate.examDate}} </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="12" :sm="24" style="padding-left:26px">
              <a-form-item label="手机号："> {{this.userDate.patientMobile}} </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="预约时间："> {{this.userDate.ctstamp}} </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :md="12" :sm="24">
              <a-form-item label="身份证号："> {{this.userDate.patientCardNo}} </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item label="是否去医院就诊过："> {{ this.userDate.caseType == '1'? '否' : this.userDate.caseType == '2'? '是' : '' }} </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :md="12" :sm="24">
              <a-form-item label="患病时间："> {{ this.userDate.illTime == '1'? '一周内' : this.userDate.illTime == '2'? '一月内' : this.userDate.illTime == '3'? '半年内' : this.userDate.illTime == '4'? '大于半年' : ''  }} </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" style="padding-left:40px">
              <a-form-item label="地址："> {{this.userDate.provinceName }} {{this.userDate.cityName }} {{this.userDate.disName }} </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :md="12" :sm="24">
              <a-form-item label="病情描述："> {{this.userDate.pridepict}} </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="24" :sm="24">
              <a-form-item label="上传资料：">
                <a-modal :visible="previewVisible" :closable="false" :footer="null" @cancel="ImagehandleCancel">
                  <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
                  <img
class="imgDetial"
:src="item"
alt=""
v-for="(item,index) in this.userDate.pictureUrl"
:key="index"
@click="seeImage(item)">
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
  </a-modal>
</template>

<script>
  import { recipeDetial } from '@/api/modular/interhospital/inquirymanage/inquirymanageManage'
  export default {
    components: {

    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        visible: false,
        confirmLoading: false,
        parameter: {},
        userDate: '',
        hackReset: true,
        previewImage: '',
        previewVisible: false
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        this.parameter.id = record.id
        this.visible = true
        recipeDetial(this.parameter).then(res => {
          this.userDate = res.data
        })
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      handleCancel () {
        this.visible = false
        this.hackReset = false
        this.$nextTick(() => {
          this.hackReset = true
        })
      },
      seeImage(path) {
        this.previewImage = path
        this.previewVisible = true
      },
      ImagehandleCancel() {
        this.previewVisible = false
      }
    }
  }
</script>
<style lang="less" scoped>
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
}
.imgDetial{
  width: 120px;
  height: 120px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}
</style>
